import gsap from 'gsap';
import View from './View';
import { getWebflowAnimationProps, parseProps } from './../lib/dataTweenParser';
import { CLASS_NAME_WEBSCROLL_FIRED } from './WebflowView';

// data-webscroll-... (scroll magic)
const DATA_ATTR_WEBSCROLL_INIT = "webscroll-initial";
const DATA_ATTR_WEBSCROLL_SHOW = "webscroll-show";
const DATA_ATTR_SETUP = "webset";
const DEFAULT_STAGGER = .05;

class WebflowListView extends View {

  constructor(id) {
    super(id);
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container);
    this.webset = parseProps(container.dataset[DATA_ATTR_SETUP]);
    if (!this.webset.selector) {
      console.warn("Unknown selector for WebflowListView", this);
      return;
    }
    const list = [...container.querySelectorAll(this.webset.selector)];
    list.forEach(this.listElementShow.bind(this));
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container);
  }
  /**
   * ############
   * ### SHOW ###
   * ############
   */
  // show list element
  listElementShow(el, index) {
    // check if element is in viewport
    if (!this.isElementInViewport(el)) return;
    const stagger = this.webset.stagger ? parseFloat(this.webset.stagger) : DEFAULT_STAGGER;
    const delay = index * stagger;
    // search for all webscroll elements
    const list = [...el.querySelectorAll('*[data-' + DATA_ATTR_WEBSCROLL_SHOW + ']')];
    list.forEach((el) => {
      this.webScrollElementShow(el, delay);
    })
  }
  // show web scroll element
  webScrollElementShow(el, delay) {
    const propsInitial = this.getTweenProps(el, DATA_ATTR_WEBSCROLL_INIT);
    const propsShow = this.getTweenProps(el, DATA_ATTR_WEBSCROLL_SHOW);
    if (propsInitial && propsShow) {
      delay = delay + (propsShow.tween.delay || 0);
      gsap.killTweensOf(el);
      gsap.set(el, {...propsInitial.tween});
      gsap.to(el, {
        duration: propsShow.time, 
        ...propsShow.tween, 
        delay,
        onComplete: () => {
          el.classList.add(CLASS_NAME_WEBSCROLL_FIRED);
        }
      });
    }
  }
  /**
   * ###############
   * ### HELPERS ###
   * ###############
   */
  // get animation props
  getTweenProps(el, name) {
    const dataAttrName = this.getDataAttributeName(name);
    return getWebflowAnimationProps(el.dataset[dataAttrName]);
  }
  // replace data-x with dataX
  getDataAttributeName(name) {
    return name.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
  }
  // is element (any part of element) visible in scrolled viewport
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const scrollY = window.scrollY;
    // element position
    const elTop = rect.top + scrollY;
    // check if element is in viewport
    return (elTop < (scrollY + window.innerHeight));
  }

}
export default WebflowListView